module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0070.jpg?v=04c8c1f8";